var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { TextBody } from '../../../Typography';
var TextBodyBox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var space = _a.theme.space;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    margin-top: ", ";\n  "])), space.xs);
});
export var CardBody = function (_a) {
    var description = _a.description, align = _a.align;
    if (description)
        return (React.createElement(TextBodyBox, { align: align },
            React.createElement(TextBody, { tag: "p", size: "sm" }, description)));
    return null;
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=CardBody.js.map